import React, { useEffect, useState } from "react";
import { useActiveBar } from "../ActiveBarContext";
import { useAuth } from "../../AuthContext";
import { unlinkCharity } from "../shared/unlinkCharity";

export default function LinkedCharities() {
  const { myBars } = useActiveBar();
  const { refreshUserBars } = useAuth();
  const [busyId, setBusyId] = useState(null);
  const [message, setMessage] = useState("");

  // Always show the latest links (the other side may have changed them).
  useEffect(() => {
    refreshUserBars().catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeCharity = async (bar) => {
    const name = bar.gaming?.charityName || "this charity";
    const ok = window.confirm(
      `Remove ${name} from ${bar.name || "your bar"}?\n\n` +
        "Use this if you've switched charities. Their gaming info and the events they posted at your bar " +
        "will be removed. Your new charity can then claim your bar from their own dashboard."
    );
    if (!ok) return;
    setBusyId(bar.id);
    setMessage("");
    try {
      const removed = await unlinkCharity(bar);
      await refreshUserBars();
      setMessage(`Removed the charity from ${bar.name || "your bar"}${removed ? ` and ${removed} of their event${removed === 1 ? "" : "s"}` : ""}.`);
    } catch (e) {
      setMessage(`Couldn't remove it: ${e.message}`);
    }
    setBusyId(null);
  };

  return (
    <div style={{ color: "#fff" }}>
      <h2 style={{ marginBottom: "10px" }}>Linked Charities</h2>
      <p style={{ marginBottom: "20px", color: "#B8B0C8" }}>
        These are the charities operating gaming at each of your bars. A charity claims
        a bar for gaming from their own dashboard — you'll see the link appear here
        automatically once they do.
      </p>
      {message && <p style={{ color: message.startsWith("Couldn't") ? "#F472B6" : "#4ADE80", marginBottom: "16px" }}>{message}</p>}

      {myBars.length === 0 ? (
        <p>You haven't claimed any bars yet.</p>
      ) : (
        myBars.map((bar) => (
          <div
            key={bar.id}
            style={{
              background: "#0D0B1A",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: "12px",
              padding: "20px",
              marginBottom: "14px",
            }}
          >
            <h3 style={{ margin: "0 0 6px" }}>{bar.name || "Unnamed Bar"}</h3>
            <p style={{ margin: 0, color: "#B8B0C8", fontSize: "16px" }}>
              {bar.address || "No address on file"}
            </p>
            <p
              style={{
                margin: "10px 0 0",
                fontSize: "16px",
                color: bar.charityId ? "#4ADE80" : "#B8B0C8",
              }}
            >
              {bar.charityId
                ? `${bar.gaming?.charityName || "A charity"} is linked to this bar for gaming`
                : "No charity linked yet"}
            </p>
            {bar.charityId && (
              <button
                type="button"
                onClick={() => removeCharity(bar)}
                disabled={busyId === bar.id}
                style={{
                  marginTop: "14px",
                  minHeight: "44px",
                  padding: "0 16px",
                  borderRadius: "8px",
                  border: "1px solid #F472B6",
                  background: "transparent",
                  color: "#F472B6",
                  fontWeight: 600,
                  fontSize: "15px",
                  cursor: "pointer",
                }}
              >
                {busyId === bar.id ? "Removing..." : "Remove this charity (switched charities)"}
              </button>
            )}
          </div>
        ))
      )}
    </div>
  );
}